// extracted by mini-css-extract-plugin
export var anchor = "AutolinkHeader-module--anchor--13be9";
export var cdsAssistiveText = "AutolinkHeader-module--cds--assistive-text--b3799";
export var cdsVisuallyHidden = "AutolinkHeader-module--cds--visually-hidden--80970";
export var header = "AutolinkHeader-module--header--75b35";
export var hideFeedback = "AutolinkHeader-module--hide-feedback--12270";
export var leftAnchor = "AutolinkHeader-module--left-anchor--34ec2";
export var rightAnchor = "AutolinkHeader-module--right-anchor--0d87b";
export var showFeedback = "AutolinkHeader-module--show-feedback--a63ed";
export var skeleton = "AutolinkHeader-module--skeleton--b88a7";